import b from 'b_';
import cx from 'classnames';
import { times } from 'lodash';
import React from 'react';
import { accessibleClick } from '@edu-frontend/modules/src/shared/lib/a11y';

import './slider-dots.scss';

interface Props {
    activeIndex: number;
    numberDots: number;
    mix?: string;
    onClick?: (slideIndex: number) => void;
}

const SliderDots = ({ activeIndex, numberDots, mix, onClick }: Props) => {
    return (
        <div className={cx('slider-dots', mix)}>
            {times(numberDots, (i) => (
                <div
                    className={b('slider-dot', { active: i === activeIndex })}
                    key={i}
                    {...accessibleClick(onClick ? () => onClick(i) : undefined)}
                />
            ))}
        </div>
    );
};

export default SliderDots;
